export const ReortLabels = {
  height: 'Height',
  weight: 'Weight',
  Hygiene_hands_and_nails: 'Hands and Nails',
  Hygiene_Hair: 'Hair',
  General_signs_Pallor: 'Pallor',
  General_signs_Cynosis: 'Cynosis',
  General_signs_Anemia: 'Anemia',
  General_signs_Clubbing: 'Clubbing',
  General_signs_Edema: 'Edema',
  General_signs_Others: 'Others',
  Head_Abnormal_Shape: 'Abnormal Shape',
  Head_Bony_Swelling: 'Bony Swelling',
  Head_Scalp_Swelling: 'Scalp Swelling',
  Head_Scalp_Bruising: 'Scalp Bruising',
  Head_Abnormal_Hair_Pigmentation: 'Abnormal Hair Pigmentation',
  Head_Others: 'Others',
  Habits_: 'Habits',
  Lymphatic_PLN_Cervical: 'Cervical',
  Lymphatic_PLN_Submandibular: 'Submandibular',
  Lymphatic_PLN_Pre_Auricular: 'Pre Auricular',
  Lymphatic_PLN_Submental: 'Submental',
  Lymphatic_PLN_Others: 'Others',
  Lymphatic_PLN_: 'Palpable Lymph Nodes',
  Skin_Itching: 'Itching',
  Skin_Tinea: 'Tinea',
  Skin_Scabies: 'Scabies',
  Skin_Impetigo: 'Impetigo',
  Skin_Contact_Dermatitis: 'Contact Dermatitis',
  Skin_Herpes: 'Herpes',
  Skin_Petecheae: 'Petecheae',
  Skin_Purpura: 'Purpura',
  Skin_Acne: 'Acne',
  Skin_Icterus: 'Icterus',
  Skin_Pigmentation: 'Pigmentation',
  Skin_Others: 'Others',
  Cardiovascular_Abnormal_heart_sounds: 'Abnormal Heart Sounds',
  Cardiovascular_Murmur: 'Murmur',
  Cardiovascular_Others: 'Others',
  Respiratory_Barky_Cough: 'Barky Cough',
  Respiratory_Hoarse_Voice: 'Hoarse Voice',
  Respiratory_Dyspnea: 'Dyspnea',
  Respiratory_Wheezing: 'Wheezing',
  Respiratory_Crepts: 'Crepts',
  Respiratory_Others: 'Others',
  Abdomen_Distended: 'Distended',
  Abdomen_Tense: 'Tense',
  Abdomen_Tender: 'Tender',
  Abdomen_Others: 'Others',
  Neurological_Lethargy: 'Lethargy',
  Neurological_Slurring_of_Speech: 'Slurring of Speech',
  Neurological_Abnormal_Body_Tone_increased: 'Increased',
  Neurological_Abnormal_Body_Tone_Decreased: 'Decreased',
  Neurological_Abnormal_Body_Tone_: 'Abnormal Body Tone',
  Neurological_Others: 'Others',
  Orthopedics_Spinal_Abnormalities_Kyphosis: 'Kyphosis',
  Orthopedics_Spinal_Abnormalities_Scoliosis: 'Scoliosis',
  Orthopedics_Spinal_Abnormalities_: 'Spinal Abnormalities',
  Orthopedics_Spinal_Abnormalities: 'Spinal Abnormalities',
  Orthopedics_Flat_Foot: 'Flat Foot',
  Orthopedics_Others: 'Others',
  Deficiencies_Suspected_Vitamins_D: 'Vitamin D',
  Deficiencies_Suspected_Vitamins_C: 'Vitamin C',
  Deficiencies_Suspected_Vitamins_: 'Vitamin',
  Deficiencies_Suspected_Vitamins_B12: 'Vitamin B12',
  Deficiencies_Suspected_Iron: 'Iron',
  Deficiencies_Suspected_Calcium: 'Calcium',
  Deficiencies_Suspected_Others: 'Others',
  Physical_Doctor_Consultation: 'Physical Doctor Consultation',
  Fitness_Program: 'Fitness Program',
  Nutrition_Program: 'Nutrition Program',
  Xray_Chest: 'Chest',
  Xray_Abdomen: 'Abdomen',
  Xray_Limbs: 'Limbs',
  Xray_Dental: 'Dental',
  Xray_Others: 'Others',
  Xray_: 'Xray',
  Ultrasound_Chest: 'Chest',
  Ultrasound_Abdomen: 'Abdomen',
  Ultrasound_Spine: 'Spine',
  Ultrasound_Others: 'Others',
  Ultrasound_: 'Ultrasound',
  CT_MRI_SCAN_Specify_Region: 'CT MRI SCAN Specify Region',
  Blood_Test_CBC: 'CBC',
  Blood_Test_Blood_Glucose: 'Blood Glucose',
  Blood_Test_KFT: 'KFT',
  Blood_Test_LFT: 'LFT',
  Blood_Test_CA_PH: 'CA PH',
  Blood_Test_Vit_D3_Levels: 'Vit D3 Levels',
  Blood_Test_Thyroid_Profile: 'Thyroid Profile',
  Blood_Test_Lipid_Profile: 'Lipid Profile',
  Blood_Test_Vit_B12: 'Vit B12',
  Blood_Test_Peripheral_Smear: 'Peripheral Smear',
  Blood_Test_Others: 'Others',
  Blood_Test_: 'Blood Test',
  Stool_Test_Routine: 'Stool Test Routine',
  Stool_Test_Culture: 'Stool Test Culture',
  Stool_Test_Others: 'Others',
  Stool_Test_: 'Stool Test',
  Urine_Test_Routine: 'Urine Test Routine',
  Urine_Test_Culture: 'Urine Test Culture',
  Urine_Test_Urine_Protein: 'Urine Test Urine Protein',
  Urine_Test_Others: 'Others',
  Urine_Test_: 'Urine Test',
  Other_Tests: 'Other Tests',
  Doctor_No: 'Doctor Name',
  Physical_Doctor_Path: 'Physical Doctor Path',
  Physical_Doctor_Remarks: 'Physical Doctor Remarks',
  Right_Ear_Tinnitus: 'Tinnitus',
  Right_Ear_Pain: 'Pain',
  Right_Ear_Malformation: 'Malformation',
  Right_Ear_Discharge: 'Discharge',
  Right_Ear_Ear_Wax: 'Ear Wax',
  Right_Ear_Others: 'Others',
  Left_Ear_Tinnitus: 'Tinnitus',
  Left_Ear_Pain: 'Pain',
  Left_Ear_Malformation: 'Malformation',
  Left_Ear_Discharge: 'Discharge',
  Left_Ear_Ear_Wax: 'Ear Wax',
  Left_Ear_Others: 'Others',
  Nose_Nasal_Polyp: 'Nasal Polyp',
  Nose_Deviated_Nasal_Septum: 'Deviated Nasal Septum',
  Nose_Sinus_Tenderness: 'Sinus Tenderness',
  Nose_Discharge: 'Discharge',
  Nose_Others: 'Others',
  Oral_Cavity_Throat_Cheilitis: 'Cheilitis',
  Oral_Cavity_Throat_Oral_Thrush: 'Oral Thrush',
  Oral_Cavity_Throat_Pain: 'Throat Pain',
  Oral_Cavity_Throat_Tonsillopharyngitis: 'Tonsillopharyngitis',
  Oral_Cavity_Throat_Tonsils: 'Tonsillitis',
  Oral_Cavity_Throat_Adenoids: 'Adenoids',
  Oral_Cavity_Throat_Others: 'Others',
  Neck_Cyst: 'Neck Cyst',
  Neck_Thyroid_Swelling: 'Thyroid Swelling',
  Neck_Others: 'Others',
  ENT_Doctor_Consultation: 'ENT Doctor Consultation',
  ENT_Other_Tests: 'ENT Other Tests',
  ENT_Doctor_No: 'ENT Doctor Name',
  ENT_Doctor_Path: 'ENT Doctor Path',
  ENT_Doctor_Remarks: 'ENT Doctor Remarks',
  Chief_Complaint_Tooth_Pain: 'Tooth Pain',
  Chief_Complaint_Bleeding_Gums: 'Bleeding Gums',
  Chief_Complaint_Decayed_Teeth: 'Decayed Teeth',
  Chief_Complaint_Inflamed_Gums: 'Inflamed Gums',
  Chief_Complaint_Others: 'Others',
  Oral_Hygiene_Poor: 'Poor Oral Hygiene',
  Habits_Thumb_Sucking: 'Thumb Sucking',
  Habits_Bottle_Sucking: 'Bottle Sucking',
  Habits_Mouth_Breathing: 'Mouth Breathing',
  Habits_Brushing_once_day: 'Brushing Once a Day',
  Habits_Others: 'Others',
  Malocclusion_Class_1: 'Class 1',
  Malocclusion_Class_2: 'Class 2',
  Malocclusion_Class_3: 'Class 3',
  Stains_Grade_1: 'Grade 1',
  Stains_Grade_2: 'Grade 2',
  Stains_Grade_3: 'Grade 3',
  Calculus_Grade_1: 'Grade 1',
  Calculus_Grade_2: 'Grade 2',
  Calculus_Grade_3: 'Grade 3',
  Dental_Doctor_Consultation: 'Dental Doctor Consultation',
  Scaling: 'Scaling',
  Filling: 'Filling',
  Orthodontic_Treatment: 'Orthodontic Treatment',
  Change_Dental_Kit: 'Change Dental Kit',
  Tooth_Rehabilitation: 'Tooth Rehabilitation',
  Extraction: 'Extraction',
  IOPA: 'IOPA',
  OPG: 'OPG',
  Fluoride_Treatment: 'Fluoride Treatment',
  Dental_Other_Tests: 'Dental Other Tests',
  Dental_Doctor_No: 'Dental Doctor Name',
  Dental_Doctor_Path: 'Dental Doctor Path',
  Dental_Remarks: 'Dental Remarks',
  Clinical_Right_Eye_Amblyopia: 'Amblyopia',
  Clinical_Right_Eye_Conjunctivis: 'Conjunctivis',
  Clinical_Right_Eye_Squint: 'Squint',
  Clinical_Right_Eye_Blepharitis: 'Blepharitis',
  Clinical_Right_Eye_Trauma: 'Trauma',
  Clinical_Right_Eye_Ptosis: 'Ptosis',
  Clinical_Right_Eye_Others: 'Others',
  Clinical_Left_Eye_Amblyopia: 'Amblyopia',
  Clinical_Left_Eye_Conjunctivis: 'Conjunctivis',
  Clinical_Left_Eye_Squint: 'Squint',
  Clinical_Left_Eye_Blepharitis: 'Blepharitis',
  Clinical_Left_Eye_Trauma: 'Trauma',
  Clinical_Left_Eye_Ptosis: 'Ptosis',
  Clinical_Left_Eye_Others: 'Others',
  Eye_Doctor_Consultation: 'Eye Doctor Consultation',
  Refraction: 'Refraction',
  Eye_Other_Tests: 'Eye Other Tests',
  Eye_Doctor_No: 'Eye Doctor Name',
  Eye_Doctor_Path: 'Eye Doctor Path',
  Eye_Remarks: 'Eye Remarks',
  Eye_Doctor_Designation: 'Eye Doctor Designation',
  Dental_Doctor_Designation: 'Dental Doctor Designation',
  Physical_Doctor_Designation: 'Physical Doctor Designation',
  ENT_Doctor_Designation: 'ENT Doctor Designation',
  Eye_Doctor_Hospital: 'Eye Doctor Hospital',
  Dental_Doctor_Hospital: 'Dental Doctor Hospital',
  Physical_Doctor_Hospital: 'Physical Doctor Hospital',
  ENT_Doctor_Hospital: 'ENT Doctor Hospital',
  Spectacles: 'Spectacles',
  Physical_Data_Created: 'Physical Data Created',
  Physical_Data_Modified: 'Physical Data Modified',
  ENT_Data_Created: 'ENT Data Created',
  ENT_Data_Modified: 'ENT Data Modified',
  Eye_Data_Created: 'Eye Data Created',
  Eye_Data_Modified: 'Eye Data Modified',
  Dental_Data_Created: 'Dental Data Created',
  Dental_Data_Modified: 'Dental Data Modified',
  Growth_Data_Created: 'Growth Data Created',
  Growth_Data_Modified: 'Growth Data Modified',
  Physical_Incomplete_Remark: 'Physical Incomplete Remark',
  ENT_Incomplete_Remark: 'ENT Incomplete Remark',
  Dental_Incomplete_Remark: 'Dental Incomplete Remark',
  Eye_Incomplete_Remark: 'Eye Incomplete Remark',
  HSG_Blood_Test_Vit_D3_Levels: 'Vit D3 Levels',
  HSG_Blood_Test_CA_PH: 'CA PH',
  HSG_Blood_Test_CBC: 'CBC',
  HSG_CT_MRI_SCAN_Specify_Region: 'CT MRI SCAN Specify Region',
  HSG_Filling: 'Filling',
  HSG_Refraction: 'Refraction',
  HSG_Ultrasound_Others: 'Others',
  HSG_Xray_Dental: 'Xray Dental',
  HSG_Eye_Doctor_Consultation: 'Eye Doctor Consultation',
  HSG_Urine_Test_Routine: 'Urine Test Routine',
  HSG_Xray_Others: 'Others',
  HSG_Blood_Test_Vit_B12: 'Vit B12',
  HSG_Spectacles: 'Spectacles',
  HSG_Change_Dental_Kit: 'Change Dental Kit',
  HSG_Physical_Doctor_Consultation: 'Physical Doctor Consultation',
  HSG_ENT_Doctor_Consultation: 'ENT Doctor Consultation',
  HSG_OPG: 'OPG',
  Refractory_Error_Right: 'Refractory Error Right',
  Refractory_Error_Left: 'Refractory Error Left',
  HSG_Scaling: 'Scaling',
  HSG_Dental_Doctor_Consultation: 'Dental Doctor Consultation',
  sys: 'Sys',
  dia: 'Dia',
  HSG_Orthodontic_Treatment: 'Orthodontic Treatment',
  HSG_Nutrition_Program: 'Nutrition Program',
  pulse: 'Pulse',
  HSG_Fitness_Program: 'Fitness Program',
  Decayed_Small: 'Milk Teeth Decayed',
  Growth_Incomplete_Remark: 'Growth Incomplete Remark',
  Growth_Remark: 'Growth Remark',
  Student_Assessment_Remark: 'Student Remark',
  Optometry_Left_Eye_NA: 'Optometry Left Eye NA',
  Optometry_Left_Eye_Spectacles_6_6: 'Optometry Left Eye Spectacles 6/6',
  Optometry_Left_Eye_Spectacles_6_9: 'Optometry Left Eye Spectacles 6/9',
  Optometry_Left_Eye_Spectacles_6_12: 'Optometry Left Eye Spectacles 6/12',
  Optometry_Left_Eye_Spectacles_6_18: 'Optometry Left Eye Spectacles 6/18',
  Optometry_Left_Eye_Spectacles_6_24: 'Optometry Left Eye Spectacles 6/24',
  Optometry_Left_Eye_Spectacles_6_36: 'Optometry Left Eye Spectacles 6/36',
  Optometry_Left_Eye_Spectacles_6_60: 'Optometry Left Eye Spectacles 6/60',
  Optometry_Left_Eye_Spectacles_NA: 'Optometry Left Eye Spectacles NA',
  Optometry_Right_Eye_NA: 'Optometry Right Eye NA',
  Optometry_Right_Eye_Spectacles_6_6: 'Optometry Right Eye Spectacles 6/6',
  Optometry_Right_Eye_Spectacles_6_9: 'Optometry Right Eye Spectacles 6/9',
  Optometry_Right_Eye_Spectacles_6_12: 'Optometry Right Eye Spectacles 6/12',
  Optometry_Right_Eye_Spectacles_6_18: 'Optometry Right Eye Spectacles 6/18',
  Optometry_Right_Eye_Spectacles_6_24: 'Optometry Right Eye Spectacles 6/24',
  Optometry_Right_Eye_Spectacles_6_36: 'Optometry Right Eye Spectacles 6/36',
  Optometry_Right_Eye_Spectacles_6_60: 'Optometry Right Eye Spectacles 6/60',
  Optometry_Right_Eye_Spectacles_NA: 'Optometry Right Eye Spectacles NA',
  naOptometryRemark: 'naOptometry',
  Decayed: 'Decayed',
  Missing: 'Missing',
  Filled: 'Filled',
};
export const VA_LEVELS = [
  '6_6',
  '6_9',
  '6_12',
  '6_18',
  '6_24',
  '6_36',
  '6_60',
  'NA', // Not Applicable/Not Tested
];

export const ReportRXData = {
  dental: [
    'Brush your teeth for at least 2 minutes to properly clean the entire mouth.',
    'A toothbrush should be changed after every 2-3 months.',
    'Use a toothpaste that contains fluoride.',
  ],
  growth: [
    'Ensure your child has three full meals a day to avoid unnecessary snacking.',
    "A playtime of at least 30 minutes a day should be factored into the children's schedule.",
    'Each meal should include proteins, carbohydrates, and fats in a balanced way to minimize junk food cravings.',
  ],
  ent: [
    'Though earwax is a natural product of the ear to keep itself clean, if it begins to hamper your hearing, see an ENT specialist to get it cleaned.',
    'The nose is the channel for smell and breathing; to protect it, please stay away from dust and keep your house free from dust.',
    'Do not use the extremes of your voice, like screaming or whispering.',
  ],
  physical: [
    'Good hygiene practices can help you to avoid many common diseases.',
    'Avoid secondhand smoking to maintain a healthy heart and lungs.',
    'An annual medical assessment with a general physician is compulsory for this age group.',
  ],
  eye: [
    'Make sure you wear sunglasses when going out into the sun, as the rays are very harsh for your eyes.',
    'Include Vitamin A in your diet.',
    'Reduce your screen time and avoid using your smartphones in a dark room.',
  ],
};

export const extractVisualAcuity = (
  responseData: Record<string, string>,
  eye: 'Right_Eye' | 'Left_Eye',
  type: 'Spectacles' | '',
): string | null => {
  for (const level of VA_LEVELS) {
    const typeSuffix = type ? `_${type}` : '';
    const key = `Optometry_${eye}${typeSuffix}_${level}`;

    if (responseData[key] === 'Y') {
      // Format the result for display
      if (level === 'NA') return 'N/A';

      return level.replace('_', '/');
    }
  }

  return null;
};

export const reportStrings = {
  leftEye: "Your child's left eye assessment needs attention.",
  rightEye: "Your child's right eye assessment needs attention.",
  dental: "Your child's dental assessment needs attention.",
  physicalHygiene: "Your child's hygiene needs attention.",
  physicalGs: "Your child's general physical signs need attention.",
  physicalHead: "Your child's head assessment needs attention.",
  physicalLymphatics: "Your child's lymphatic assessment needs attention.",
  physicalSkin: "Your child's skin assessment needs attention.",
  physicalCardio: "Your child's cardiovascular assessment needs attention.",
  physicalRespiratory: "Your child's respiratory assessment needs attention.",
  physicalAbdomen: "Your child's abdomen assessment needs attention.",
  physicalNeuro: "Your child's neurological assessment needs attention.",
  physicalOrthopedics: "Your child's orthopedics assessment needs attention.",
  physicalDeficiencies:
    'Deficiencies are suspected in your child based on physical signs and need attention.',
  rightEar: "Your child's right ear assessment needs attention.",
  leftEar: "Your child's left ear assessment needs attention.",
  nose: "Your child's nose assessment needs attention.",
  throat: "Your child's throat assessment needs attention.",
  neck: "Your child's neck assessment needs attention.",
};
